import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { Accordion } from '../../../lib/components';
import { useTranslation } from 'react-i18next';

export const TaskErrorElement: FC<{
  title: string;
  details: { msg: string; content: string; row: number };
}> = ({ title, details }) => {
  const { t } = useTranslation();

  return (
    <Accordion
      sx={{
        backgroundColor: 'grey.50',
        borderRadius: '0.5rem',
        marginTop: '1rem',
        '&:last-of-type': {
          borderRadius: '0.5rem'
        }
      }}
      headlineData={{ mainText: title }}
      withHeadlinePadding
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'max-content auto',
          alignItems: 'center',
          margin: '1rem',
          padding: '1rem',
          borderRadius: '0.5rem',
          backgroundColor: 'common.white',
          gap: '0.5rem'
        }}
      >
        <Typography padding="0.25rem" fontWeight="bold">
          {t('tasks:ERROR_MSG')}
        </Typography>
        <Typography padding="0.25rem" textAlign="left">
          {details.msg}
        </Typography>
        <Typography padding="0.25rem" fontWeight="bold">
          {t('tasks:ERROR_ROW')}
        </Typography>
        <Typography padding="0.25rem" textAlign="left">
          {details.row}
        </Typography>
      </Box>
    </Accordion>
  );
};
